import { useEffect, useRef, useState } from "react";
import { signInWithEmailAndPassword, getAuth } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";
import { useTranslation } from "react-i18next";

import { useAlert } from "react-alert";
import comittyLogo from "../../components/logos/logo.svg";
import "./login.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import userAction from "../../redux/users/action";
import { Loader2 } from "../../helper/loader";
import { db } from "../../firebase";
import FormField from "../../components/formField/FormField.jsx";
import LanguageSwitcher from "../../components/LanguageSwitcher.jsx";
import Aurora from "../../components/aurora/Aurora.jsx";

export const Login = () => {
  const { t } = useTranslation("login");
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const { setUser } = userAction;
  const dispatch = useDispatch();
  const alert = useAlert();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showWelcomeOverlay, setShowWelcomeOverlay] = useState(false);
  const [welcomeName, setWelcomeName] = useState("");
  const welcomeTimeoutRef = useRef(null);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function handleChange(name, value) {
    setFormData({ ...formData, [name]: value });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    const auth = getAuth();
    await signInWithEmailAndPassword(auth, formData?.email, formData?.password)
      .then(async (userCredential) => {
        // Connecté
        const userId = userCredential.user.uid;
        const userRef = doc(db, "Store", userId);
        let loadedUser;

        await getDoc(userRef)
          .then((snapshot) => {
            const data = {
              id: snapshot.id,
              ...snapshot.data(),
            };
            loadedUser = data;
          })
          .catch((err) => {
            console.log("Fetch user failed: " + err);
          });

        dispatch(setUser(loadedUser));
        const displayName =
          loadedUser?.username?.trim() ||
          loadedUser?.email?.split("@")?.[0] ||
          userCredential?.user?.email?.split("@")?.[0] ||
          "";
        setWelcomeName(displayName);

        setLoader(false);
        setShowWelcomeOverlay(true);
        welcomeTimeoutRef.current = setTimeout(() => {
          navigate("/dashboard/pos");
        }, 1800);
      })
      .catch((error) => {
        console.log(error.message);
        setLoader(false);
        alert.show(t("invalidEmailOrPassword"));
      });
  };

  useEffect(() => {
    return () => {
      if (welcomeTimeoutRef.current) {
        clearTimeout(welcomeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="loginPage">
      <Aurora />

      <div className="loginPageInner">
        <div className="commityImg">
          <img className="img-fluid" src={comittyLogo} alt={t("altText")} />
        </div>
        <div className="loginForm">
          <h3>{t("welcome")}</h3>
          <div className="desc">{t("festivalSubscriberAccess")}</div>
          <form onSubmit={handleSubmit}>
            <FormField
              name="email"
              value={formData.email}
              onChange={(value) => handleChange("email", value)}
              label={t("email")}
            />
            <FormField
              name="password"
              value={formData.password}
              onChange={(value) => handleChange("password", value)}
              label={t("password")}
              type="password"
              showPassword={showPassword}
              togglePassword={togglePasswordVisibility}
            />
            <Link to={"/forget-password"} className="forget">
              {t("forgotPassword")}
            </Link>
            <button className="loginBtn" type="submit">
              {t("login")}
            </button>
            <button className="signupBtn " onClick={() => navigate("/signup")}>
              {t("noAccount")}
            </button>
          </form>
          <div className="languageSwitcherContainer">
            <LanguageSwitcher />
          </div>
        </div>
      </div>
      {showWelcomeOverlay && (
        <div className="loginWelcomeOverlay" role="status" aria-live="polite">
          <div className="loginWelcomeOverlayInner">
            <h2
              className={`${welcomeName?.length > 26 ? "is-xlong" : welcomeName?.length > 16 ? "is-long" : ""}`.trim()}
            >
              {t("welcomeBackTitleWithName", { name: welcomeName || t("welcome") })}
            </h2>
          </div>
        </div>
      )}
      {loader && <Loader2 loader={loader} />}
    </div>
  );
};
